<template>
    <div class="container mx-auto">
        <div class="pb-2 w-full border-b border-gray-300">
            <div class="flex items-center justify-between">
                <h1 class="module-header text-2xl">Tasks</h1>

                <button v-if="showCreateNew && canCreateTask" @click="$modal.show('new-project-task')" class="ml-5 flex items-center justify-center space-x-2 btn btn-small btn-indigo">
                    <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                    <p class="text-white">New Task</p>
                </button>
            </div>
        </div>

        <div>
            <table v-if="sortedTasks.length" class="mt-5 w-3/4">
                <thead class="cursor-pointer">
                    <tr>
                        <th class="pl-4">Type</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Priority</th>
                        <th>Task</th>
                        <th class="text-center">Completed?</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="task in sortedTasks" :key="task.id">
                        <td class="pl-4">{{ task.task_category }}</td>
                        <td>{{ task.start_formatted }}</td>
                        <td>{{ task.end_formatted }}</td>
                        <td>
                            <div class="badge" :class="task.priority_color">
                                <div class="flex items-baseline space-x-1">
                                    <span class="text-base font-variant-all-small-caps">{{ task.priority }}</span>
                                </div>
                            </div>
                        </td>
                        <td>{{ task.task }}</td>
                        <td class="text-center">{{ task.is_complete ? 'Yes' : 'No' }}</td>
                        <td class="flex justify-center space-x-3">
                            <button v-if="canEditTask(task.project_id)" @click="editTask(task)" type="button">
                                <inline-svg name="edit-pencil" classes="w-5 h-5 cursor-pointer"></inline-svg>
                            </button>
                            <button v-if="canDeleteTask(task.project_id)" @click="confirmDeleteTask(task.id)" type="button">
                                <inline-svg name="trash" classes="w-5 h-5 cursor-pointer"></inline-svg>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-else>
                <p class="none-found">No Tasks Found</p>
            </div>
        </div>

        <modal name="new-project-task" width="60%" height="auto" click-to-close draggable=".modal-header">
            <new-project-task :project-id="projects.selectedProject.id"></new-project-task>
        </modal>

        <modal name="edit-project-task" width="60%" height="auto" click-to-close draggable=".modal-header">
            <edit-project-task :task-data="selectedTask"></edit-project-task>
        </modal>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            showCreateNew: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                selectedTask: {}
            }
        },

        computed: {
            ...mapState(['projects']),

            sortedTasks() {
                return _.orderBy(this.projects.selectedProject.tasks, ['start_date_formatted', 'start_time_formatted']);
            },
            canCreateTask() {
                return this.$gate.can('create', 'project');
            }
        },

        methods: {  
            canEditTask(projectId) {
                return this.$gate.can('update', 'project', projectId);
            },

            canDeleteTask(projectId) {
                return this.$gate.can('delete', 'project', projectId);
            },
            editTask(task) {
                this.selectedTask = task;

                this.$modal.show('edit-project-task');
            },

            confirmDeleteTask(taskId) {
                this.$swal({
                    title: 'Delete this task?',
                    text: "ALL data will be lost",
                    type: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Delete it',
                    confirmButtonClass: 'btn btn-red',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then(async (result) => {
                    if (result.value) {
                        await axios.delete('/project/tasks/' + taskId)
                            .then(response => {
                                this.projects.selectedProject.tasks = _.remove(this.projects.selectedProject.tasks, task => task.id != taskId);
                            })
                            .catch(error => {
                                console.log(error);
                            }
                        );
                    }
                });
            }
        }
    }
</script>
